// extracted by mini-css-extract-plugin
module.exports = {"picture":"Pic_picture__30iTf","simpleLeak":"Pic_simpleLeak__2-Su4","ste2":"Pic_ste2__3WHuY","unior":"Pic_unior__2c6se"};